// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"446":"f81f56d7","647":"0d449256"}[chunkId] + ".js";
};